@if (show) {
  <div [className]="'mmodal'">
    <div class="mmodal-body">
      <div>
        <button  class="closeXBtn" type="submit" (click)='close()' ></button>
        <br/><br/>
        <span class="usa-modal__heading margin-left-4" id="modal-1-heading">
          {{msg}}
        </span>
      </div>
      <br/>
      <button  class="usa-button  usa-button--active closeBtn" type="submit" (click)='close()' >
        <div>
          <span [innerHTML]="btnLabel"></span>
        </div>
      </button>
    </div>
  </div>
}
@if (show) {
  <div class="mmodal-background"></div>
}

